import { Component, OnInit } from '@angular/core';

import { RestService} from 'src/app/services/rest.service';
import { Router,ActivatedRoute } from '@angular/router';
import { Form, User} from 'src/app/models/RestModels';
import { BuildInfo } from 'src/app/models/BuildInfo';


type Falseable = boolean | number | null;

@Component({
	selector: 'app-menu',
	templateUrl: './menu.component.html',
	styleUrls: ['./menu.component.css']
})

export class MenuComponent implements OnInit {
	constructor( public rest: RestService, public router: Router, public route: ActivatedRoute ) {}

	external_base_url: string = this.rest.getExternalAppUrl();

	showCentros:boolean = false;
	show_logout: boolean = false;
	user:Partial<User> = {};
	queryParams ={t:Date.now()}

	show_users_menu: Falseable = false;
    show_menu_users: Falseable = false;
    show_menu_stock: Falseable = false;
    show_menu_shippings: Falseable = false;
    show_menu_catalogs: Falseable = false;
    show_menu_prices: Falseable = false;
    show_menu_accountant: Falseable = false;
    show_menu_production: number | boolean  = false;
    show_menu_reservations: Falseable = false;
    show_menu_settings: Falseable = false;
	show_old_menu: Falseable = false;
	show_old_production_menu: Falseable = false;
    show_menu_rentals: Falseable = false;
    show_menu_reports: Falseable = false;
    show_menu_commissions: Falseable = false;

	build_info = BuildInfo;

	forms_list:Form[] = [];

	/*
	active_section_dashboard:boolean=false;
	active_section_project:boolean=false;
	active_section_financials:boolean=false;
	active_section_users:boolean=false;
	active_section_settings:boolean=false;
	active_section_catalogs:boolean=false;
	active_section_purchasing:boolean=false;
	*/

	active_section:Record<string,boolean>= {
		'dashboard': false,
		'users': false,
		'catalogs':false,
		'finantials':false,
		project: false,
		purchasing: false,
		settings: false
	};

	t:number = Date.now();
	build_time:number = Date.now();
	build_date:Date	= new Date();

	ngOnInit()
	{
		this.route.url.subscribe(()=>
		{
			this.updateTime();
			this.user = this.rest.current_user;
			this.t = Date.now();
		});

		this.route.queryParams.subscribe(()=>
		{

			this.show_menu_users = this.rest.current_permission.add_user || this.rest.current_permission.add_providers||
				this.rest.current_permission.pos;

			this.show_menu_stock = this.rest.current_permission.add_stock
				|| this.rest.current_permission.global_add_stock
				|| this.rest.current_permission.stocktake;

			this.show_menu_catalogs = this.rest.current_permission.add_items;
			this.show_menu_shippings = this.rest.current_permission.send_shipping || this.rest.current_permission.global_send_shipping;
			this.show_menu_prices = this.rest.current_permission.store_prices || this.rest.current_permission.add_items;

			this.show_menu_accountant = false;
			this.show_menu_production = this.rest.current_permission.production;// || this.rest.current_permission.validate_production;
			this.show_menu_reservations = false;
			this.show_menu_reports = this.rest.current_permission.reports;

			this.show_menu_settings = this.rest.current_permission.add_user
				|| this.rest.current_permission.add_commandas
				|| this.rest.current_permission.add_roles;

			this.show_menu_rentals = this.rest.local_preferences.reservations_enabled && this.rest.current_permission.pos;
			this.show_menu_commissions = this.rest.current_permission.view_commissions
				|| this.rest.current_permission.pay_commissions
				|| this.rest.current_permission.approve_commissions;

			this.updateTime();
		});

		this.rest.form.search({limit:9999}).subscribe({
			next:(response)=>
			{
				this.forms_list = response.data;
			},
			error:(error)=>
			{
				this.rest.showError(error);
			}
		});

		this.route.queryParams.subscribe(this.updateTime);
		this.route.paramMap.subscribe( this.updateTime );
	}

	setActiveSection(section:string):void
	{
		for(let i in this.active_section )
		{
			this.active_section[i] = i == section;
		}
		console.log( this.active_section );
	}

	updateTime()
	{
		this.queryParams = { t: Date.now() };
		this.t = Date.now();
		if( this.rest )
		{
	//		this.rest.hideMenu();
		}
		//console.log('NEW TIME SBB',this.queryParams );
	}

	showLogoutModal() {
		this.show_logout=true;
	}

	logout()
	{
		this.rest.logout(true);
	}
	onSwipe(evt)
	{
		let x = Math.abs(evt.deltaX) > 40 ? (evt.deltaX > 0 ? 'right' : 'left'):'';
		if( x == 'left' )
		{
			this.rest.hideMenu();
		}
	}

	updateData(evt:Event)
	{
		evt.preventDefault();
		evt.stopPropagation();

		this.rest.syncOffLineItems()
		.then((resp)=>
		{
			this.rest.showSuccess('Se actualizaron los datos');
		},(error)=>
		{
			this.rest.showError('No se pudieron actualizar los articulos');
		})
	}

	syncData(evt:Event)
	{
		evt.preventDefault();
		evt.stopPropagation();

		this.rest.forceSyncOfflineItems()
		.then(()=>
		{
			this.rest.showSuccess('Datos de soporte actualizados');
			setTimeout(()=>
			{
				window.location.reload(true);
			},1000);

		},(error)=>this.rest.showError( error ));
	}
}
